import { motion } from "framer-motion";
import { Star, Award, Users, Building } from "lucide-react";

const Clinica = () => {
  const features = [
    {
      icon: Star,
      value: "5.0",
      label: "Avaliação Google",
    },
    {
      icon: Users,
      value: "10+",
      label: "Anos de Experiência",
    },
    {
      icon: Award,
      value: "8",
      label: "Especialidades",
    },
    {
      icon: Building,
      value: "Ed. Tojal",
      label: "Localização Premium",
    },
  ];

  // Equipa médica com destaque
  const equipa = [
    {
      nome: "Dr. Gonçalo Andrade",
      especialidade: "Implantologia",
      foto: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/7ncfh0w4_IMG_9776%20-%20co%CC%81pia.JPG",
    },
    {
      nome: "Dra. Maria Pereira",
      especialidade: "Ortodontia",
      foto: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/6e4o0blc_Captura%20de%20ecra%CC%83%202026-04-07%2C%20a%CC%80s%2011.22.35.png",
    },
    {
      nome: "Dra. Matilde Miroto",
      especialidade: "Odontopediatria",
      foto: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/ocj20apt_WhatsApp%20Image%202026-04-07%20at%2011.45.02.jpeg",
    },
  ];

  // Imagens reais da clínica
  const images = [
    {
      url: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/q1wi272a_Captura%20de%20ecra%CC%83%202026-04-02%2C%20a%CC%80s%2018.31.28.png",
      alt: "Caso de reabilitação estética",
      className: "col-span-1 md:col-span-5 row-span-2",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/zm6p8yly_DSC_7204.JPG",
      alt: "Trabalho dentário de precisão",
      className: "col-span-1 md:col-span-4 row-span-1",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_dentista-viseu/artifacts/eu8lalrt_DSC_4683.JPG",
      alt: "Resultado de tratamento",
      className: "col-span-1 md:col-span-3 row-span-1",
    },
  ];

  return (
    <section
      id="clinica"
      className="py-16 md:py-24 bg-white"
      data-testid="clinica-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="text-xs font-semibold tracking-[0.15em] uppercase text-[#8A8A8A] block mb-4">
            Conheça-nos
          </span>
          <h2
            className="font-outfit text-3xl sm:text-4xl font-semibold text-[#1A1A1A] tracking-tight mb-4"
            data-testid="clinica-title"
          >
            A Clínica Cligeral II Care
          </h2>
          <p className="text-lg text-[#4A4A4A] max-w-2xl mx-auto">
            Localizada no coração de Viseu, oferecemos cuidados de saúde oral de
            excelência num ambiente moderno e acolhedor.
          </p>
        </motion.div>

        {/* Stats Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16"
        >
          {features.map((feature, index) => (
            <div
              key={feature.label}
              className="bg-[#FAFAFA] border border-gray-100 rounded-2xl p-6 text-center"
              data-testid={`stat-${feature.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <feature.icon className="w-8 h-8 text-[#1A1A1A] mx-auto mb-3" />
              <span className="font-outfit text-2xl md:text-3xl font-bold text-[#1A1A1A] block">
                {feature.value}
              </span>
              <span className="text-sm text-[#4A4A4A]">{feature.label}</span>
            </div>
          ))}
        </motion.div>

        {/* Bento Gallery */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 mb-12 md:mb-16"
        >
          {images.map((image, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`bento-item ${image.className} rounded-2xl overflow-hidden`}
              data-testid={`gallery-image-${index}`}
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover min-h-[200px] md:min-h-[250px]"
                loading="lazy"
              />
            </motion.div>
          ))}
        </motion.div>

        {/* Equipa Médica - COM DESTAQUE */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="bg-[#1A1A1A] rounded-3xl p-8 md:p-12 text-white"
          data-testid="equipa-section"
        >
          <div className="text-center mb-10">
            <h3 className="font-outfit text-2xl md:text-3xl font-semibold mb-4">
              Equipa de Médicos Dentistas
            </h3>
            <p className="text-white/70 max-w-2xl mx-auto">
              A nossa equipa multidisciplinar reúne médicos dentistas especializados em diversas áreas,
              garantindo um atendimento completo e personalizado para cada paciente.
            </p>
          </div>

          {/* Team Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {equipa.map((membro, index) => (
              <motion.div
                key={membro.nome}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center"
                data-testid={`membro-${index}`}
              >
                {/* Foto ou Avatar */}
                <div className="w-24 h-24 mx-auto mb-4 rounded-full overflow-hidden border-2 border-white/30">
                  {membro.foto ? (
                    <img
                      src={membro.foto}
                      alt={membro.nome}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-white/20 flex items-center justify-center">
                      <span className="text-3xl font-bold text-white/60">
                        {membro.nome.split(" ")[1]?.[0] || membro.nome[0]}
                      </span>
                    </div>
                  )}
                </div>
                <h4 className="font-outfit text-lg font-semibold text-white mb-1">
                  {membro.nome}
                </h4>
                <p className="text-white/60 text-sm">{membro.especialidade}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Card da Clínica */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-12 flex justify-center"
        >
          <div className="bg-white rounded-2xl p-8 shadow-lg text-center max-w-sm border border-gray-100">
            <img
              src="/logo.png"
              alt="Cligeral II Care Logo"
              className="w-20 h-20 mx-auto mb-4 object-contain"
            />
            <h4 className="font-outfit text-xl font-semibold text-[#1A1A1A] mb-2">
              Cligeral II Care
            </h4>
            <p className="text-[#4A4A4A] text-sm mb-4">
              Centro Avançado de Reabilitação Estética
            </p>
            <div className="flex items-center justify-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-5 h-5 text-[#1A1A1A]"
                  fill="#1A1A1A"
                />
              ))}
            </div>
            <p className="text-sm text-[#4A4A4A] mt-2">
              Avaliação 5.0 no Google
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Clinica;
